export default {"src":"/_next/static/media/calendar.f000527a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};